import { fetchWithTokenRefresh } from './AuthActions';
import env from '../globals/environment';
import { get_user_metrics } from './types';

export const getUserMetrics = (timeframe) => {
  return async (dispatch, getState) => {
    try {
      let date = new Date();
      switch (timeframe) {
        case 'today':
          date.setDate(date.getDate() - 1);
          break;
        case 'week':
          date.setDate(date.getDate() - 7);
          break;
        case 'month':
          date.setDate(date.getMonth() - 1);
          break;
      }

      const { headers } = getState().authStore;
      let url = (timeframe === 'all' || !timeframe)
        ? `${env.backendUrl}/metrics/push`
        : `${env.backendUrl}/metrics/push?after=${date.toISOString()}`;

      const response = await fetchWithTokenRefresh(url, { headers })(dispatch);


      if (!response.ok) throw new Error('Could not get metrics from api');
      else {
        const metrics = await response.json();
        dispatch({
          type: get_user_metrics,
          payload: metrics
        });
      }

    } catch (error) {
      console.log(error);
    }
  };
};


// WEBPACK FOOTER //
// ./src/actions/MetricsActions.js